import { render, staticRenderFns } from "./SalaryEffectTypeFilter.vue?vue&type=template&id=04da7f5c&"
import script from "./SalaryEffectTypeFilter.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports